/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import AdobeDCViewAppBase from "bundle/preview/react-component/AdobeDCViewApp";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import { logging } from "dc-core";

const logHelper = (serviceRegistry, message) => {
    const config = serviceRegistry.getService("AppStore").getConfig();
    logging.getLogger("App").error(message, config.clientId, config.eventOrigin);
};

export default class AdobeDCViewApp extends AdobeDCViewAppBase {
    shouldBlockRender() {
        const appStore = ServiceRegistry.getService("AppStore");
        return !appStore.isValidLicense || appStore.appRenderingBlocked;
    }

    log() {
        const appStore = ServiceRegistry.getService("AppStore");
        if (!appStore.isValidLicense) {
            logHelper(ServiceRegistry, "File preview blocked due to invalid license");
        } else {
            logHelper(ServiceRegistry, "File preview blocked as preview failed to load");
        }
    }
}
